import { useWorkforceStep } from "../hooks/useWorkforceStep";
import { WorkforceStepContainer } from "../components/WorkforceStepContainer";
import { Info, Public, CheckCircle } from "@mui/icons-material";
import { Box, useMediaQuery } from "@mui/material";
import { StepWorkforceCoverage } from "./steps/StepWorkforceCoverage";
import { StepWorkforceSummary } from "./steps/StepWorkforceSummary";
import { StepWorkforceForm } from "./steps/StepWorkforceForm";
import { WorkforceStepper } from "./WorkforceStepper";
import { formatedPayload } from "../helpers/formatedPayload";
import { useState } from "react";
import ConfirmWorkforceModal from "./WorkforceConfirmCreate";

export const WorkforceCreate = ({ defaultValues, workforceMutation }) => {
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const isXs = useMediaQuery("(max-width:600px)");

  const isApplicant = defaultValues?.status === "APPLICANT";
  const totalSteps = isApplicant ? 2 : 3;
  const { activeStep, formData, nextStep, previousStep, finishStep } = useWorkforceStep({ defaultValues, totalSteps });

  const handleFinish = () => {
    const data = formatedPayload(formData);
    workforceMutation.mutate(data, {
      onSuccess: (res) => console.log("Created successfully"),
      onError: (err) => console.error("Error:", err),
      onSettled: () => console.log("Finish"),
    });
  };

  const steps = isApplicant
    ? [
        {
          label: "General Info",
          description: "Basic applicant information",
          icon: <Info fontSize="small" />,
          component: <StepWorkforceForm defaultValues={formData} onNext={nextStep} />,
        },
        {
          label: "Summary",
          description: "Review and confirm before saving",
          icon: <CheckCircle fontSize="small" />,
          component: <StepWorkforceSummary data={formData} onBack={previousStep} onConfirm={() => setIsConfirmModalOpen(true)} />,
        },
      ]
    : [
        {
          label: "General Info",
          description: "Basic employee information",
          icon: <Info fontSize="small" />,
          component: <StepWorkforceForm defaultValues={formData} onNext={nextStep} />,
        },
        {
          label: "Coverage Area",
          description: "Define where this employee can operate",
          icon: <Public fontSize="small" />,
          component: <StepWorkforceCoverage data={formData} onNext={nextStep} onBack={previousStep} />,
        },
        {
          label: "Summary",
          description: "Review and confirm before saving",
          icon: <CheckCircle fontSize="small" />,
          component: <StepWorkforceSummary data={formData} onBack={previousStep} onConfirm={() => setIsConfirmModalOpen(true)} />,
        },
      ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isXs ? "column" : "row",
        width: "100%",
        height: "100%",
        bgcolor: "var(--fx-surface-base, #FFFFFF)",
        borderRadius: 2,
        position: "relative",
      }}
    >
      <Box
        sx={{
          width: isXs ? "100%" : "180px",
          borderRight: isXs ? "none" : "1px solid #eee",
          borderBottom: isXs ? "1px solid var(--fx-surface-border, #E2E8F0)" : "none",
          pb: isXs ? 1 : 0,
          px: !isXs && 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: isXs ? "auto" : "100%",
        }}
      >
        <WorkforceStepper orientation={isXs ? "horizontal" : "vertical"} activeStep={activeStep} steps={steps} />
      </Box>
      <Box
        sx={{
          flex: 1,
          height: "100%",
          overflowY: "auto",
          p: 3,
        }}
      >
        <WorkforceStepContainer steps={steps} activeStep={activeStep} />
      </Box>

      <ConfirmWorkforceModal
        open={isConfirmModalOpen}
        onClose={() => setIsConfirmModalOpen(false)}
        onConfirm={() => finishStep(handleFinish)}
        isApplicant={isApplicant}
      />
    </Box>
  );
};
